
(function ($) {
    $.fn.rlVideoVimeo = function () {

        (function () {
            if (typeof NodeList.prototype.forEach === "function") return false;
            NodeList.prototype.forEach = Array.prototype.forEach;
        })();

        var VIMiframeIds = [];

        var VIMiframes = document.querySelectorAll(".videoWrapper .vimeoapi");
        let vimCount = 0;
        VIMiframes.forEach(function (f) {
           
           if (VIMiframeIds.indexOf(f.id) > -1) {
              var newId = f.id + '-' + vimCount,
                  transcriptIndex = f.id.indexOf("-") + 1,
                  transId = f.id.slice(transcriptIndex);

              var VIMaccordiona = document.querySelector("a[href='#transcript" + transId + "']"),
                 VIMaccordionb = document.querySelector("#transcript" + transId),
                 newTransId = transId + '-' + vimCount;

              f.setAttribute('id', (newId));

              if (VIMaccordiona !== null) {
                 VIMaccordiona.setAttribute('href', '#transcript' + newTransId);
                 VIMaccordionb.setAttribute('id', 'transcript' + newTransId);
              }

              vimCount++;
           }
           VIMiframeIds.push(f.id);
        });
        
        VIMiframeIds.forEach(function (VIMiframe) {
            var iframe = document.getElementById(VIMiframe);
            var player = new Vimeo.Player(iframe);

            $('#' + VIMiframe).parent('.videoWrapper').children('.play').on('click', function () {
                player.play();
                $(this).addClass('hide');
            });

            player.on('play', function () {
                $('#' + VIMiframe).parent('.videoWrapper').children('.play').addClass('hide');
            });
        });

       

    }
}(jQuery));

(function ($) {
  $.fn.rlVideoVimeoCookieless = function() {

    // @TODO: move to global polyfills include.
    (function () {
      if (typeof NodeList.prototype.forEach === "function") return false;
      NodeList.prototype.forEach = Array.prototype.forEach;
    })();

    window.addEventListener('OneTrustGroupsUpdated',
      function() {
        var groups = OnetrustActiveGroups.split(',');
        if (groups.indexOf('C0003') === -1) {
          var vimeoiframes = document.querySelectorAll('.vimeoapi');
          vimeoiframes.forEach(function(vimeoiframe) {
            
            var srcValue = vimeoiframe.getAttribute('data-src');
            if (srcValue != 'undefined') {
                if (srcValue.indexOf('dnt=1') === -1) {

                    if (srcValue.indexOf('?') === -1) {
                        srcValue = srcValue + '?dnt=1';
                    }
                    else {
                        srcValue = srcValue + '&dnt=1';
                    }                
                }
                vimeoiframe.removeAttribute('data-src');
                vimeoiframe.setAttribute('src', srcValue);
            }
          });
        }
      });
  }
}(jQuery));

(function ($) {
  $.fn.rlVideoVimeoInitialise = function () {

    document.querySelector('.vimeoapi').addEventListener('load', function (e) { $().rlVideoVimeo(); });
    $().rlVideoVimeoCookieless();
  };
  
}(jQuery));



